import React, { useRef, useState } from "react";
// import ServicesSlider from "../../Component/Home/Slider/ServicesSlider";
// import TestSlider from "../../Component/Home/Slider/TestSlider";

import BlogImg1 from "../../Assets/home/BlogImg1.jpg";
import BlogImg2 from "../../Assets/home/BlogImg2.jpg";
import Blog3 from "../../Assets/home/Blog3.jpg";

import img1 from "../../Assets/home/img1.png";
import rightarrow from "../../Assets/navbar/right-arrow.svg";
import logo from "../../Assets/home/logo.svg";
import img2 from "../../Assets/home/img2.png";
import item1 from "../../Assets/home/item1.svg";
import item2 from "../../Assets/home/item2.svg";
import item5 from "../../Assets/home/item5.png";
import item3 from "../../Assets/home/item3.svg";
import item4 from "../../Assets/home/item4.svg";
import item8 from "../../Assets/home/item8.svg";
import img7 from "../../Assets/home/img7.png";
import Navbar from "../../Component/Home/Navbar";
import Footer from "../../Component/Home/footer/Footer";
import HdfcPaymentButton from "../Customers/PaymentPage/HDFCPaymentButton";
import { useEffect } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { validateToken } from "../../Auth/authUtils";
import axios from "../../axiosInstance";

import DownloadPdfButton from "../../Component/Customers/DownloadPDFButton";

import Marquee from "react-fast-marquee";

const blogCards = [
  {
    id: 1,
    title:
      "Proud Moment for BCV ClaimPro Assist Pvt. Ltd.",
    image:
      "https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/Blogs/BlogImg1.jpg",
     content: (
      <>
        <p>
          We are delighted to announce that Mr. Bhavneesh Malik, the founder and
          managing director of BCV ClaimPro Assist Pvt. Ltd., has been honored
          with the prestigious "Leading Innovator in Logistics Solutions" award
          by the ET Business Awards, an initiative by The Times of India Group.
          This award is a recognition of Mr. Malik’s visionary leadership,
          commitment to innovation, and his continuous efforts to bring positive
          change in the logistics sector. Under his guidance, ClaimPro Assist
          has become a trusted name in accident logistics, insurance support,
          and vehicle recovery services across India.
        </p>

        <blockquote className="m-2 border-l-4 border-[#21A6E9] pl-2 italic text-[#444] bg-[#F0F8FF] py-2">
          "We are deeply honored by this recognition"
        </blockquote>

        <p>A heartfelt congratulations to the entire team!</p>
      </>
    ),
  },
  {
    id: 2,
    title:
      "Prestigious Recognition for ClaimPro Assist at Infotech Forum 2025.",
    image:
      "https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/Blogs/Blog3.jpg",
    
    content: (
      <>
        <p>
          We are delighted to share that our Chief Technology Officer, Mr. Mohan
          Shah, has been honoured with the prestigious “Eminent CIOs of India
          2025-2026” award by VAR India.

          <blockquote className="m-2 border-l-4 border-[#21A6E9] pl-2 italic text-[#444] bg-[#F0F8FF] py-2">
            The award was presented at the VAR India Infotech Forum 2025, held
            on 4th July 2025 at Hotel Hyatt Regency, New Delhi.
          </blockquote>

          This recognition is a testament to Mr. Shah’s visionary leadership,
          technological excellence, and his relentless pursuit of innovation in
          the tech-enabled Vehicle Support Management space. His contributions
          continue to shape the future of ClaimPro Assist and the broader
          industry. We congratulate Mr. Shah and his team on this well-deserved
          achievement and look forward to many more milestones together!
        </p>
      </> 
    ),
  },
];

const testimonials = [
  {
    name: "Ravi Sharma",
    role: "Transporter – Jaipur",
    text: `Booked a recovery van through the ClaimPro app after a highway breakdown—help arrived within 30 minutes. The process was fast, and I didn’t even need to make a call!`,
  },
  {
    name: "Sandeep Mehta",
    role: "Fleet Owner – Delhi NCR",
    text: `I used the app to request crane service when my truck tipped over. The ClaimPro team responded immediately, and the crane was on-site faster than I expected. Very professional service!`,
  },
  {
    name: "Mukesh Verma",
    role: " Driver – Haryana",
    text: `ClaimPro's recovery van service is excellent. The app tracked the vehicle in real-time, and I was updated at every step. Truly reliable in emergency situations.`,
  },
  {
    name: "Anil Chauhan",
    role: " Logistics Executive – Punjab",
    text: `The crane support was quick, safe, and efficient. I managed the entire request through the mobile app, and the team handled the vehicle carefully without any additional damage.`,
  },
  {
    name: " Deepak Joshi",
    role: " Fleet Manager – Rajasthan",
    text: `We’ve used ClaimPro’s app for crane and recovery services multiple times. The experience has always been smooth, timely, and professional. A must-have app for commercial fleets!`,
  },
];

function Home() {
  const navigate = useNavigate();
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  const scrollRef = useRef();

  const scroll = (direction) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === "left" ? -300 : 300,
        behavior: "smooth",
      });
    }
  };
  // const scrollTestimonials = useRef(null);

  // useEffect(() => {
  //   const container = scrollTestimonials.current;
  //   if (!container) return;

  //   const scrollAmount = container.offsetWidth;

  //   const interval = setInterval(() => {
  //     if (
  //       container.scrollLeft + container.clientWidth >=
  //       container.scrollWidth
  //     ) {
  //       container.scrollTo({ left: 0, behavior: "smooth" });
  //     } else {
  //       container.scrollBy({ left: scrollAmount, behavior: "smooth" });
  //     }
  //   }, 10000);

  //   return () => clearInterval(interval);
  // }, []);

  useEffect(() => {
    const checkLogin = async () => {
      const isValid = await validateToken();
      const userRole = localStorage.getItem("userRole");
      const currentStep = localStorage.getItem("currentStep");

      if (isValid) {
        console.log("currentstepa", currentStep);

        if (userRole === "customer") {
          navigate("/customer-home-page", { replace: true });
        } else if (["Management", "IT", "Operations", "HR"].includes(userRole)) {
          navigate("/admin-dashboard-vendor-customer", { replace: true });
        } else if (userRole === "recoveryVan") {
          navigate("/crane-driver-home", { replace: true });
        }else if (userRole === "craneandrecoveryVan") {
          navigate("/crane-driver-home", { replace: true });
        }else if (userRole === "vendorDriver") {
          navigate("/vendor-driver-home", { replace: true });
        } else {
          localStorage.clear();
          sessionStorage.clear();
          navigate("/loginPage", { replace: true });
        }
      } else {
        setIsCheckingAuth(false); // show login form only if not logged in
      }
    };

    checkLogin();
  }, []);

  const impactRef = useRef(null);
  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const newsRef = useRef(null);

  // Scroll handler
  const scrollToImpact = () => {
    if (impactRef.current) {
      impactRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const scrollToAbout = () => {
    if (aboutRef.current) {
      aboutRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const scrollToHome = () => {
    if (homeRef.current) {
      homeRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const scrollToNews = () => {
    if (newsRef.current) {
      newsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const location = useLocation();

  // Auto scroll when redirected with scroll state
  useEffect(() => {
    if (location.state?.scrollTo === "about") {
      // Delay scroll slightly to ensure DOM is ready
      setTimeout(() => {
        // scrollToImpact();
        scrollToAbout();

        // Clean up state so back button doesn't trigger again
        navigate(location.pathname, { replace: true, state: {} });
      }, 100); // 100ms is usually safe
    }
    if (location.state?.scrollTo === "home") {
      // Delay scroll slightly to ensure DOM is ready
      setTimeout(() => {
        scrollToHome();

        // Clean up state so back button doesn't trigger again
        navigate(location.pathname, { replace: true, state: {} });
      }, 100); // 100ms is usually safe
    }
  }, [location, navigate]);

  return (
    <>
      {isCheckingAuth ? (
        <div /> // or loader/spinner
      ) : (
        <>
          {/* <Navbar/> */}
          <Navbar onAboutClick={scrollToAbout} onHomeClick={scrollToHome} />
          {/* <DownloadPdfButton data={sampleData}></DownloadPdfButton> */}

          <div
            className="hero-section overflow-hidden relative"
            id="home"
            ref={homeRef}
          >
            <img
              src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/home/img1-compressed.png"
              className="absolute bottom-0 right-0 md:block hidden h-auto w-[30%] max-w-[500px]"
              alt=""
            />
            <div className="flex items-center flex-col w-full max-w-[90%] mx-auto md:pt-[10%] pt-[20%] text-center">
              <h1 className="font-satoshi font-[700] text-white md:text-[4vw] text-[8vw] leading-tight md:px-0 px-[5%] pb-[10%]">
                <span
                  style={{ textShadow: "2px 2px 4px rgba(12, 181, 223, 0.88)" }}
                  className="text-blue-300"
                >
                  Reliable Support
                </span>{" "}
                When <br /> You Need It Most
              </h1>
              <div
                hidden
                className="bg-[#21A6E9] flex items-center justify-between py-[5px] rounded-full h-[50px] px-[6px]"
              >
                <button className="font-satoshi font-[400] text-[1.1rem] leading-[33.6px] pr-[136px] text-white pl-[12px] whitespace-nowrap">
                  Get Started Now
                </button>
                <img
                  src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg"
                  className="h-[40px]"
                  alt=""
                />
              </div>
              <Link to="/">
                <img
                  src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/home/logo-compressed.png"
                  className="md:pt-[7%] pt-[20%] w-[80%] max-w-[340px] h-auto"
                  alt=""
                />
              </Link>
            </div>
          </div>

          <div
            className="bg-white md:px-[5%] px-[5%] md:pb-[12%] pb-[10%]"
            ref={aboutRef}
            id="about"
          >
            <h6 className="font-[900] font-satoshi text-[#1B2E3F] md:text-[4vw] text-[8vw] leading-tight text-center pt-[5%] pb-[0px]">
              THE COMPLETE VEHICLE SOLUTION
            </h6>
            <div className="grid md:grid-cols-2 grid-cols-1 md:gap-[5%] gap-[20px] md:pt-[8%] pt-[5%]">
              <div>
                <img
                  src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/home/img2-compressed.png"
                  className="w-full h-auto"
                  alt=""
                />
              </div>
              <div>
                <button className="bg-[#ffffff] hover:bg-[#21A6E9] items-center border border-[#21A6E93D] text-[#21A6E9] hover:text-[#FFFFFF] py-[12px] px-[24px] uppercase rounded-full font-satoshi font-[400] text-[1rem] leading-[26px] ease-in transition-all">
                  About us
                </button>
                <h6 className="max-w-full w-full font-satoshi font-[500] text-[#1B2E3F] md:text-[3vw] text-[6vw] leading-snug pt-[18px] pb-[20px]">
                  Support When You Need it
                </h6>
                <p className="font-[400] font-satoshi text-[1rem] leading-[1.8rem] text-[#515151] pb-[20px]">
                  ClaimPro Assist is a tech-driven roadside assistance and
                  vehicle recovery service provider, committed to supporting
                  drivers and fleet owners across India during unexpected
                  breakdowns, accidents, and emergencies. With a dedicated
                  network of crane operators, recovery vans, legal experts, and
                  on-site mechanics, we ensure swift response and complete
                  support — from the road to resolution. Our mission is to make
                  vehicle recovery and legal assistance faster, safer, and more
                  reliable than ever before.
                </p>
                <h6 className="font-satoshi font-semibold mb-5">
                  "Your fleet is in safe hands — with ClaimPro Assist by your
                  side."
                </h6>
                {/* <div className="bg-[#21A6E9] flex py-[5px] items-center rounded-full pr-[6px] pl-[26px] w-fit">
                  <button className="font-satoshi font-[400] text-[1rem] leading-[33.6px] pr-[20px] text-white">
                    Read More
                  </button>
                  <img
                    src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg"
                    className="h-[40px] w-[40px]"
                    alt=""
                  />
                </div> */}
              </div>
            </div>
          </div>

          <div
            id="impact"
            ref={impactRef}
            className="bg-[#21A6E912] md:px-[5%] px-[5%] pt-[8%]"
          >
            <button className="bg-[#ffffff] hover:bg-[#21A6E9] items-center border border-[#21A6E93D] text-[#21A6E9] hover:text-[#FFFFFF] py-[12px] px-[24px] uppercase rounded-full font-satoshi font-[400] text-[1rem] leading-[26px] ease-in transition-all">
              Our Impact
            </button>
            <div className="grid md:grid-cols-2 grid-cols-1 md:gap-[8%] gap-[30px] pt-[18px] items-center md:pb-[8%] pb-[40px]">
              <div>
                <h6 className="font-satoshi font-[500] text-[#1B2E3F] md:text-[3vw] text-[6vw] leading-snug">
                  Making a Real Difference
                </h6>
              </div>
              <div>
                <p className="font-[400] font-satoshi text-[1rem] leading-[1.8rem] text-[#515151]">
                  We help commercial vehicle operators recover faster from
                  accidents, reducing downtime and losses. Our on-ground and
                  legal support ensures smooth recovery and business continuity.
                </p>
              </div>
            </div>
            <div className="grid md:grid-cols-5 grid-cols-1 gap-y-[20px] items-center pb-[10%]">
              <div className="flex flex-col md:gap-[70px] gap-[30px]">
                <div className="flex flex-col items-center">
                  <img
                    src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/home/item1.svg"
                    className="h-[70px] w-[70px]"
                    alt=""
                  />
                  <h6 className="font-[900] font-satoshi text-[3vw] text-center pt-[30px]">
                    1000+
                  </h6>
                  <p className="font-[500] font-satoshi text-[1.25rem] leading-[2.5rem] text-black">
                    Claims Settled
                  </p>
                </div>
                <div className="flex flex-col items-center">
                  <img
                    src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/home/item2.svg"
                    className="h-[70px] w-[70px]"
                    alt=""
                  />
                  <h6 className="font-[900] font-satoshi text-[3vw] text-center pt-[30px]">
                    1000+
                  </h6>
                  <p className="font-[500] font-satoshi text-[1.25rem] leading-[2.5rem] text-black">
                    On-Spot Repairs
                  </p>
                </div>
              </div>
              <div className="md:col-span-3 col-span-1">
                <img
                  src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/home/item5-compressed.png"
                  className="w-full h-auto"
                  alt=""
                />
              </div>
              <div className="flex flex-col md:gap-[70px] gap-[30px]">
                <div className="flex flex-col items-center">
                  <img
                    src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/home/item3.svg"
                    className="h-[70px] w-[70px]"
                    alt=""
                  />
                  <h6 className="font-[900] font-satoshi text-[3vw] text-center pt-[30px]">
                    500+
                  </h6>
                  <p className="font-[500] font-satoshi text-[1.25rem] leading-[2.5rem] text-black">
                    Workshop
                  </p>
                </div>
                <div className="flex flex-col items-center">
                  <img
                    src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/home/item4.svg"
                    className="h-[70px] w-[70px]"
                    alt=""
                  />
                  <h6 className="font-[900] font-satoshi text-[3vw] text-center pt-[30px]">
                    1500+
                  </h6>
                  <p className="font-[500] font-satoshi text-[1.25rem] leading-[2.5rem] text-black">
                    Crane/Hydra
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="md:px-[80px] px-[20px] md:pt-[128px] pt-[40px] bg-white">
            <Link to="/service-page">
              <button className="bg-[#ffffff] hover:bg-[#21A6E9] items-center border border-[#21A6E93D] text-[#21A6E9] hover:text-[#FFFFFF] py-[12px] px-[24px] uppercase rounded-full font-satoshi font-[400] text-[18px] leading-[26px] ease-in transition-all">
                Services
              </button>
            </Link>
            <div className="grid md:grid-cols-2 grid-cols-1 md:gap-[70px] gap-[30px] pt-[18px] items-center md:pb-[130px] pb-[40px]">
              <div>
                <h6 className="max-w-[507px] mb-0 w-full font-satoshi font-[500] md:text-[48px] text-[24px] md:leading-[62.4px] leading-[30px] text-[#1B2E3F]">
                  Driven to Respond Powered to Assist
                </h6>
              </div>
              <div>
                <p className="font-[400] mb-0 font-satoshi text-[18px] leading-[30px] text-[#515151]">
                  We go beyond basic breakdown help — offering a full suite of
                  services, including crane, recovery vans, on-site mechanics,
                  garage coordination, and expert legal support to get your
                  vehicle and driver released swiftly. Whether it’s an accident,
                  a roadside halt, or a legal hurdle, we’re built to respond
                  when it matters most.
                </p>
              </div>
            </div>
            <div className="services-slider">{/* <ServicesSlider /> */}</div>
          </div>

          <div className=" bg-white md:pt-[100px] pt-[20px] md:pb-[160px] pb-[100px] md:px-[80px] px-[20px]">
            <div className="flex flex-col items-center">
              <button className="bg-[#ffffff] hover:bg-[#21A6E9] border border-[#21A6E93D] text-[#21A6E9] hover:text-[#FFFFFF] py-[12px] px-[24px] uppercase rounded-full font-satoshi font-[400] text-[18px] leading-[26px] ease-in transition-all">
                TESTIMONIALS
              </button>
              <h6 className="mb-0 font-satoshi pt-[18px] font-[500] md:text-[48px] text-[24px] md:leading-[62.4px] leading-[30px] text-[#000000] text-center pb-[68px]">
                What Our Customer Says
              </h6>
            </div>

            <div className="relative overflow-visible no-scrollbar w-[90vw] px-0 md:px-5 h-[10rem] mt-3">
              {/* Scrollable Testimonials Container */}
              <Marquee pauseOnHover={true} speed={25}>
                {testimonials.map((card, index) => (
                  <div key={index} className="w-full flex flex-shrink-0 px-1">
                    <div className="bg-white rounded-[16px] shadow-md p-3 text-center mx-auto max-w-[500px] h-[250px] mb-[2rem] flex flex-col">
                      <div className="h-[150px] mt-2 overflow-hidden">
                        <h6 className="font-[400] mb-0 font-satoshi text-[18px] leading-[30px] text-[#515151]">
                          <span className="text-[#21A6E9] text-lg">"</span>
                          {card.text}
                          <span className="text-[#21A6E9] text-lg">"</span>
                        </h6>
                      </div>
                      <div className="text-center mt-4">
                        <h4 className="text-[#21A6E9] font-semibold text-[12px] md:text-[14px]">
                          {card.name}
                        </h4>
                        <p className="text-gray-500 text-[10px] md:text-[12px]">
                          {card.role}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </Marquee>
            </div>
          </div>

          <div
            className="bg-[#EFF9FD] md:px-[80px] px-[20px] md:py-[128px] py-[40px]"
            id="news"
            ref={newsRef}
          >
            <button className="bg-[#ffffff] hover:bg-[#21A6E9] border border-[#21A6E93D] text-[#21A6E9] hover:text-[#FFFFFF] py-[12px] px-[24px] uppercase rounded-full font-satoshi font-[400] text-[18px] leading-[26px] ease-in transition-all">
              News
            </button>
            <div className="flex md:items-center items-start md:gap-0 gap-[18px] md:flex-row flex-col justify-between  md:pb-[2rem] pb-[1rem]">
              <h6 className="pl-2 max-w-[620px] mb-0 w-full font-satoshi font-[500] md:text-[48px] text-[24px] md:leading-[62.4px] leading-[30px] text-[#0A0119]">
                Expert Tips, News & Insights
              </h6>
              <Link to="/Blogs">
                <div className="bg-[#21A6E9] flex py-[5px] items-center justify-between rounded-full pr-[6px] pl-[26px] max-w-[180px] w-full">
                  <button className="font-satoshi font-[400] text-[18px] leading-[33.6px] pr-[20px] text-[#FFFFFF]">
                    View All
                  </button>
                  <img
                    src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg"
                    className="h-[40px] w-[40px]"
                    alt=""
                  />
                </div>
              </Link>
            </div>
            <div className="grid md:grid-cols-2 grid-cols-1 md:gap-[44px] gap-[20px]">
              {blogCards.map((blog, index) => (
                <div key={blog.id}>
                  <img
                    src={blog.image}
                    className="rounded-[16px] h-[350px] w-[600px] object-cover"
                    alt={`Blog ${blog.id}`}
                  />
                  <Link to="/read-blogs" state={{ blogId: blog.id }}>
                    <div className="flex items-center justify-between gap-[40px] pt-[30px]">
                      <h6 className="mb-0 font-satoshi font-[500] md:text-[25px] text-[16px] md:leading-[41.6px] leading-[20px] text-[#515151]">
                         {blog.title}
                      </h6>
                      <img
                        src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/home/item8.svg"
                        alt=""
                        className="md:h-auto h-[60px] w-[60px] cursor-pointer flex-shrink-0"
                      />
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>

          <Footer
            onAboutClick={scrollToAbout}
            onHomeClick={scrollToHome}
            onNewsClick={scrollToNews}
          />
        </>
      )}
    </>
  );
}

export default Home;
